import axios from './axios';
let base
if(!sessionStorage.getItem('chOrEn')){
  base = ''; sessionStorage.setItem('chOrEn','1')
}else{
  base = ''; sessionStorage.setItem('chOrEn',sessionStorage.getItem('chOrEn'))
}
if (process.env.NODE_ENV === 'development') {
    //console.log('测试环境==>', process.env.NODE_ENV);
    base = 'http://www.ispunion.org:8096'
    //base = 'http://shequ.goufangbian.com.cn/fengheapi'
} else {
    base = 'http://www.ispunion.org:8096'
    // base = 'http://shequ.goufangbian.com.cn/fengheapi'
    //console.log('生产环境==>', process.env.NODE_ENV);
}
// export const Login = params => {
//   return axios.post(`${base}/volunteer/remove/`, params);
// };
//首页轮播

export const bannerinfo = params => { 
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/bannerInfo/list`, params,  {headers:{'chOrEn':chOrEn,contentType: "application/x-www-form-urlencoded; charset=utf-8"}})
};
//联盟介绍
export const getByNav = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/bannerInfo/getByNavigationId`, params,  {headers:{'chOrEn':chOrEn},contentType: "application/x-www-form-urlencoded; charset=utf-8"})
};
// 成员单位
export const memberunitList = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/memberunitInfo/list`, params,  {headers:{'chOrEn':chOrEn}})
};
// 成员
export const memberuni = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/memberunitInfo/page`, params,  {headers:{'chOrEn':chOrEn}})
};
// 关于联盟
export const baseByNav = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/baseInfo/getByNavigationId`, params,  {headers:{'chOrEn':chOrEn}})
};
// 展览交流分页
export const articlePage = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/articleInfo/page`, params,  {headers:{'chOrEn':chOrEn}})
};
// 展览不分页
export const articleList = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/articleInfo/list`, params,  {headers:{'chOrEn':chOrEn}})
};
// 展览详情
export const info = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/articleInfo/info`, params,  {headers:{'chOrEn':chOrEn}})
};
// email
export const email = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/contentusInfo/getByNavigationId`, params,  {headers:{'chOrEn':chOrEn}})
};
// 作品展示 不分页
export const worksList = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/worksInfo/list`, params,  {headers:{'chOrEn':chOrEn}})
};
// 作品展示 分页
export const worksPage = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/worksInfo/page`, params,  {headers:{'chOrEn':chOrEn}})
};
// 会员申请 联系我们
export const contentget = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/contentusInfo/getByNavigationId`, params,  {headers:{'chOrEn':chOrEn}})
};
// 添加数据，网站前台用不到保存方法
export const articleSave = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/articleInfo/save`, params,  {headers:{'chOrEn':chOrEn}})
};
// 论坛详情
export const  detailsForum = params => {
  let chOrEn = sessionStorage.getItem("chOrEn")
  return axios.post(`${base}/articleInfo/info`, params,  {headers:{'chOrEn':chOrEn}})
};